import type { FC } from 'react'
import { Flex, Spin } from '@/components'

import { CategoryCard } from '../category-card'
import { SC_DocumentsListWrapper } from './styled'

type T_CategoriesProps = {
  cats?: { name: string; title?: { ru?: string } }[]
  isLoading: boolean
  push: (item: any) => void
}

export const Categories: FC<T_CategoriesProps> = ({ cats, isLoading, push }) => {
  if (isLoading) {
    return (
      <Flex justify='center' align='center'>
        <Spin size='large' />
      </Flex>
    )
  }

  return (
    <SC_DocumentsListWrapper>
      {cats?.map((c) => (
        <CategoryCard
          key={c.name}
          title={c.title?.ru ?? c.name}
          onClick={() =>
            push({
              name: 'category-inner',
              title: c.title?.ru ?? c.name,
              categoryId: c.name,
            })
          }
        />
      ))}
    </SC_DocumentsListWrapper>
  )
}
